import type { UseDocumentProps, UseDocumentResult } from './index'
import type { LazyExecution } from '../useList/useLazyList'
import { useLazyList } from '../useList/useLazyList'
import get from 'lodash/get'
import isArray from 'lodash/isArray'
import omit from 'lodash/omit'
import { useBuildDocumentQueryOptions } from './useBuildDocumentQueryOptions'

export type UseLazyDocumentResult<T = any> = Omit<UseDocumentResult<T>, 'subscribeToMore' | 'fieldErrors'> &
  LazyExecution<T>

export type UseLazyDocumentProps<T = any> = Omit<UseDocumentProps<T>, 'subscribeToUpdates'>

export function useLazyDocument<T = any>(props: UseLazyDocumentProps<T>): UseLazyDocumentResult<T> {
  const { entity, limit, skip, filter, options, query } = useBuildDocumentQueryOptions<T>(props)

  const { list, ...listResult } = useLazyList<T>({
    query,
    entity,
    projection: props.projection,
    sort: props.sort,
    limit,
    skip,
    filter,
    options,
  })

  let document: any = list ?? null
  if (isArray(document)) {
    document = get(listResult, 'list[0]')
  }

  const omitResult = omit(listResult, ['list', 'pageInfo', 'loadMoreEntries', 'subscribeToMore'])

  return {
    ...omitResult,
    document,
  } as UseLazyDocumentResult<T>
}
